module.exports = __webpack_public_path__ + "img/market-participants-en.fbb67fd0.png";